import type { MyBusiness } from "@teamna/shared";
import { useSetMyTeamPhoto } from "@teamna/web-client/hooks/use-photos.ts";
import { useMe } from "@teamna/web-client/hooks/use-member.ts";
import { showToast } from "../components/index.ts";
import { SinglePhotoEditor } from "./SinglePhotoEditor.tsx";

/**
 * Your own profile photo at one business, for a person on its team (owner, admin or staff). Each
 * business keeps its own photo of you. You can always replace or remove a photo that the owner
 * gave you.
 */
export function MyTeamPhoto({ business }: { business: MyBusiness }) {
  const me = useMe();
  const write = useSetMyTeamPhoto(business.businessId);
  const name = me.data?.user.fullName ?? "You";
  return (
    <SinglePhotoEditor
      name={name}
      photoUrl={business.myPhotoUrl ?? null}
      label="Your photo"
      saving={write.isPending && write.variables !== null}
      removing={write.isPending && write.variables === null}
      error={write.error}
      onSave={(jpeg, done) =>
        write.mutate(jpeg, {
          onSuccess: () => {
            done();
            showToast("Your photo is saved.");
          },
        })
      }
      onRemove={() => write.mutate(null, { onSuccess: () => showToast("Your photo is removed.") })}
    />
  );
}
